import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryCream = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M12.372 7.07s1.672 0 1.672 1.152v9.393a.5.5 0 0 1-.17.387c-.423.355-1.62 1.198-3.454 1.198s-3.03-.843-3.454-1.198a.5.5 0 0 1-.17-.387V8.222c0-1.151 1.672-1.151 1.672-1.151m3.904 0V5.047c0-1.152-1.116-1.152-1.116-1.152m1.116 3.176s-.513.578-1.952.578-1.952-.578-1.952-.578m2.788-3.176V1.778S11.283.8 10.42.8s-.836.978-.836.978v2.117m1.672 0s.027.3-.836.3c-.666 0-.836-.3-.836-.3m0 0s-1.116 0-1.116 1.152V7.07"
    />
  </svg>
);
export default SvgPrimaryCream;
